import { useState, useEffect } from 'react'

import { Drawer } from 'antd'
import { useSelector } from 'react-redux'

import { selectUser } from '../../reducers/UserReducer'
import SmartTable, { SmartTableDataTypes } from './SmartTable'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const ContactPersonSpecialityYears = ({ getContactPersons, title, visible, onClose }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [contactPersons, setContactPersons] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (typeof getContactPersons === 'function' && user && visible) {
      setLoading(true)
      getContactPersons(user).then((data) => {
        setContactPersons(data)
        setLoading(false)
      })
    }
  }, [getContactPersons, user, visible])

  const COLUMNS = [
    {
      type: SmartTableDataTypes.STRING,
      name: t('lastname'),
      key: 'firstname'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('firstname'),
      key: 'lastname'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Email'),
      key: 'email'
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Phone number'),
      key: 'phone'
    }
  ]

  const handleClose = () => {
    setContactPersons([])
    onClose()
  }

  return (
    <Drawer
      title={title ?? ''}
      width='640px'
      onClose={handleClose}
      visible={visible}
    >
      <SmartTable
        columns={COLUMNS}
        data={contactPersons}
        loading={loading}
        noDataText={t('Without person contact')}
      />
    </Drawer>
  )
}

export default ContactPersonSpecialityYears
